import { render, staticRenderFns } from "./goods-price.vue?vue&type=template&id=785d00b6&scoped=true&"
import script from "./goods-price.vue?vue&type=script&lang=js&"
export * from "./goods-price.vue?vue&type=script&lang=js&"
import style0 from "./goods-price.vue?vue&type=style&index=0&id=785d00b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785d00b6",
  null
  
)

export default component.exports